import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import routes from '../constants/routes';
import { isJwtTokenStored } from '../helpers/authHelper';

import Main from './Main/Main';
import SearchForm from './Jurisdiction/SearchForm';
import HistoryList from './Proceeding/HistoryList';
import MyProceedings from './Account/MyProceedings';
import OpenProceeding from '../components/Proceeding/OpenProceeding';

const privateRoutes = [
    {
      path: routes.MY_PROCEEDINGS,
      component: MyProceedings,
    }
  ];

const PrivateRoute = ({ path, component: Component }) => (
    <Route
      exact
      path={path}
      render={props =>
        isJwtTokenStored() ? (
          <Component {...props} />
        ) : (
          <Redirect to={ routes.LOGIN } />
        )
      }
    />
);

const Home = () => {
    return (
        <Switch>
            <Route exact path={ routes.HOME } render={() => <Main />} />
            <Route exact path={ routes.PROCEEDING } render={() => <OpenProceeding />} />
            <Route exact path={ routes.SEARCH(':jurisdiction') } render={() => <SearchForm />} />
            <Route exact path={ routes.HISTORY(':jurisdiction',':number') } render={() => <HistoryList />} />
            {
              privateRoutes.map(route => (
                  <PrivateRoute 
                      key={route.path}
                      exact
                      { ...route }
                  />
              ))
            }
            <Route
              path="*"
              render={() => (
                <Redirect to={routes.HOME} />
              )}
            />
        </Switch>
    );
};

export default Home;